import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../../hooks/useAuth';
import './Banner.css';
import { FaPause, FaPlay } from "react-icons/fa";

function Banner() {
  const [currentImage, setCurrentImage] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  
  const { isAuthenticated } = useAuth();
  const linkPath = isAuthenticated ? "/Profile" : "/New-Account";
  const buttonText = isAuthenticated ? "Check Your Account" : "Join the pack!";

  useEffect(() => {
    let timer;
    if (!isPaused) {
      timer = setTimeout(() => {
        setCurrentImage((prevImage) => (prevImage + 1) % 3);
      }, 5000); // Change image every 5 seconds
    }

    return () => clearTimeout(timer); // Cleanup the timer
  }, [currentImage, isPaused]);

  const images = [
    {
      src: "https://res.cloudinary.com/dboapnol9/image/upload/v1779136050/DSC_0616_yq5rzc.jpg",
      alt: "Several dogs playing together on a grassy lawn at DJ's Dog Bar",
    },
    {
      src: "https://res.cloudinary.com/dboapnol9/image/upload/v1779136050/DSC_0593_vgvm7b.jpg",
      alt: "Dogs gathered on the grass, ready to play in the park",
    },
    {
      src: "https://res.cloudinary.com/dboapnol9/image/upload/v1779136052/DSC_0582_yix21p.jpg",
      alt: "A happy dog running across the grass with a toy in its mouth",
    },
  ];

  const setImageIndex = (index) => {
    setCurrentImage(index);
    setIsPaused(true); // Optionally pause the rotation when manually selecting an image
  };

  const togglePause = () => {
    if (isPaused) {
      // If currently paused and the button is clicked, change the image immediately.
      setCurrentImage(prevImage => (prevImage + 1) % 3);
    }
    setIsPaused(!isPaused);
  };

  return (
    <div className="banner-container">
      {images.map(({ src, alt }, index) => (
        <img 
          key={index} 
          src={src} 
          alt={alt} 
          className={`banner-image ${currentImage === index ? 'active' : ''}`}
        />
      ))}
      <div className="banner-text">
        <h1>Welcome to <br /> DJ's Dog Bar</h1>
        <p>Your go-to spot for friends, fun, and furry companions</p>
        <Link to={linkPath}><button className="callToAction-button">{buttonText}</button></Link>
      </div>
      <section className="bubble">
      <div className="banner-selectors">
        {images.map((_, index) => (
          <div key={index} className="banner-selector-container">
            <span 
              className={`bone-end  ${currentImage === index ? 'active' : ''}`}
              onClick={() => setImageIndex(index)}
            />
              <span 
                className={`dog-bone  ${currentImage === index ? 'active' : ''}`}
                onClick={() => setImageIndex(index)}
              ><strong></strong>
              </span>
            <span 
              className={`bone-end  ${currentImage === index ? 'active' : ''}`}
              onClick={() => setImageIndex(index)}
            />
          </div>
        ))}
      </div>
      </section>
      <button className={`pause-button ${isPaused ? 'paused' : ''}`} onClick={togglePause}>
        {isPaused ? <FaPlay /> : <FaPause />}
      </button>
    </div>
  );
}

export default Banner;
